import { Pipe, PipeTransform } from '@angular/core';
import parsePhoneNumber from 'libphonenumber-js';

@Pipe({
    name: 'phonenumber',
    standalone: true,
})
export class PhoneNumberPipe implements PipeTransform {
    transform(value: any): any {
        return parsePhoneNumber(value, 'DK').formatNational();
    }
}
